import { render, staticRenderFns } from "./Empire.vue?vue&type=template&id=298f02b4&scoped=true&"
import script from "./Empire.vue?vue&type=script&lang=js&"
export * from "./Empire.vue?vue&type=script&lang=js&"
import style0 from "./Empire.vue?vue&type=style&index=0&id=298f02b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f02b4",
  null
  
)

export default component.exports